import type { ZodType } from 'zod';

import { z } from 'zod';

const monthlyDataSchema = <T extends ZodType>(s: T) => z.tuple([s, s, s, s, s, s, s, s, s, s, s, s]);

export const dashboardStatisticsSchema = z.object({
  totalIncomeThisYear: z.number(),
  totalCopyrightThisYear: z.number(),
  averageCopyrightPastYears: z.number(),
  lastActiveYear: z.number().nullable(),
  barChartDataByYear: z.record(
    z.string(),
    z.object({
      totalPerformanceExclVat: monthlyDataSchema(z.number()),
      totalCopyrightExclVat: monthlyDataSchema(z.number()),
    }),
  ),
  pieChartDataByYear: z.record(
    z.string(),
    z.object({
      total: z.object({ count: z.number(), totalFcExclVat: z.number() }),
      approved: z.object({ count: z.number(), totalFcExclVat: z.number() }),
      expired: z.object({ count: z.number(), totalFcExclVat: z.number() }),
      paidCurrentQuarter: z.object({ count: z.number(), totalFcExclVat: z.number() }),
      paidPreviousQuarters: z.object({ count: z.number(), totalFcExclVat: z.number() }),
    }),
  ),
  outstandingInvoices: z.object({
    total: z.object({ count: z.number(), amount: z.number() }),
    approved: z.object({ count: z.number(), amount: z.number() }),
    expired: z.object({ count: z.number(), amount: z.number() }),
    invoices: z.array(
      z.object({
        title: z.string(),
        clientName: z.string(),
        dueDate: z.iso.datetime({ offset: true }),
        amount: z.number(),
      }),
    ),
  }),
});

export const invitationsStatisticsSchema = z.object({
  totalReferralProfit: z.number(),
});

export const pricingStatisticsSchema = z.object({
  totalAdvantageByYear: z.record(z.string(), z.number()),
});
